export class ProposalProject{
    constructor(
        id,
        status,
        jiraEpicKey,
        title,
        description,
        deletedAt,
        userOwnerId,
        userOwnerName
    ){
        this.id = id;
        this.status = status;
        this.jiraEpicKey = jiraEpicKey;
        this.title = title;
        this.description = description;
        this.deletedAt = deletedAt;
        this.userOwnerId = userOwnerId;
        this.userOwnerName = userOwnerName;
    }
    static createFromResponseData(responseData){
        return new ProposalProject(
            responseData.id,
            responseData.status,
            responseData.jiraEpicKey,
            responseData.title,
            responseData.description,
            responseData.deletedAt,
            responseData.userOwnerId,
            responseData.userOwnerName
        );
    }
};